import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';

export default defineNuxtPlugin(() => {
  const interactiveStore = useInteractiveStore();
  const router = useRouter();
  const globalStore = useGlobalStore();
  if (interactiveStore.isPageSpeedBot) return;
  const runtimeConfig = useRuntimeConfig();
  const isProd = runtimeConfig.public.isProd;
  if (!isProd || globalStore.webview) return;

  function init() {
    const script = document.createElement('script');
    script.src = 'https://vk.com/js/api/openapi.js?169';
    script.type = 'text/javascript';
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);
    script.addEventListener('load', () => {
      try {
        if (window?.VK?.Retargeting) {
          window.vkAsyncInit = function () {
            window.VK.Retargeting.Init('VK-RTRG-1474189-gma7B');
          };
          router.afterEach((_, from) => {
            if (from.name && window?.VK?.Retargeting) {
              window.VK.Retargeting.Hit();
            }
          });
        }
      } catch (e) {
        console.error('vl plugin', e);
      }
    });
  }

  interactiveStore.addFunction(init);
});
